import React from "react";
import { Toaster } from "react-hot-toast";

const BlankLayout = (props: { children: React.ReactNode }) => {
  return (
    <div className="min-h-screen w-full bg-background">
      <main className="flex min-h-screen flex-1 flex-col">
        {props.children}
      </main>
      <Toaster
        position="bottom-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          className: "",
          duration: 5000,
          style: {
            background: "#363636",
            color: "#fff",
          },
          success: {
            duration: 3000,
          },
        }}
      />
    </div>
  );
};

export default BlankLayout; 